import React, { useEffect, useState } from "react";
import Colors from "../../../../stories/assets/Colors";
import Fonts from "../../../../stories/assets/Fonts";
import { Button } from "../../../../stories/Button/Button";
import {
  HeadingBg,
  TennisSport,
  SoccerSport,
  BaseballSport,
  SkatingSport,
  FootballSport,
  BasketballSport,
  GolfSport,
  logoColor,
  sunIcon1,
  sunIcon2,
  sunIcon3,
  sunIcon4,
  sunIcon5,
  sunIcon6,
} from "../../../../constant/imagePath";
import { Container } from "react-bootstrap";
import { BeforeLoginHeader } from "../../../../stories/BeforeLoginHeader/BeforeLoginHeader";
import { PlayCard } from "../../../../stories/PlayCard/PlayCard.jsx";
import PlayCardClasses from "../../../../stories/PlayCard/playcard.module.css";
import classes from "./Steps.module.css";
import { Row, Col } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { isMobileViewHook } from "../../../../CustomHooks/isMobileViewHook";
import { DoubleCalander } from "./../../../../stories/DoubleCalander/DoubleCalander";
import DoubleCalanderCss from "./../../../../stories/DoubleCalander/DoubleCalander.module.css";
import { DropDown } from "../../../../stories/DropDown/DropDown";
import Maps from "../../../../components/Maps";
import { Checkbox } from "../../../../stories/Checkbox/Checkbox";
import GetAMatchMobile from "../StepsMobile";

function GetAMatchDesktop() {
  const history = useHistory();
  const [selectedValue, setSelectedValue] = useState(null);
  const [isMobile, setIsMobile] = useState(false);
  const [pageCount, setPageCount] = useState(1);

  const [coordinate, setCoordinate] = useState({});
  const [locationDetail, setLocationDetail] = useState({});
  const [address, setAddress] = useState();
  const [radius, setRadius] = useState(null);

  const [progressBar, setProgressBar] = useState(16.66);

  const [coachQualities, setCoachQualities] = useState([]);
  const [unSelectCoachQualities, setUnSelectCoachQualities] = useState();

  const [skillsTaught, setSkillsTaught] = useState([]);
  const [unSelectSkillsTaught, setUnSelectSkillsTaught] = useState();

  const timingCardArray = [
    { title: "Morning", icon: sunIcon1, timing: "6-9 am" },
    { title: "LateMorning", icon: sunIcon2, timing: "9-12 am" },
    { title: "Afternoon", icon: sunIcon3, timing: "12-3 pm" },
    { title: "Late afternoon", icon: sunIcon4, timing: "3-6 pm" },
    { title: "Evening", icon: sunIcon5, timing: "6-9 pm" },
    { title: "Late Evening", icon: sunIcon6, timing: "9-12 pm" },
  ];
  const [timingCard, setTimingCard] = useState(timingCardArray[0]);

  const coachQualitiesArray = [
    "Friendly to kids",
    "Supportive",
    "Energetic",
    "Discipline",
    "Trustworthy",
    "Knowledgable",
    "Competitive",
    "Motivator",
    "Good Communicator",
    "Patient",
    "Passionate",
    "Skillful",
    "Caring",
    "Good Listener",
    "Proactive",
  ];

  const skillsTaughtArray = [
    "Forehand",
    "Drop Shot",
    "Approach Shot",
    "Backhand",
    "Lob",
    "Backhand Smash",
    "Top Spin",
    "Backswing",
    "Serve",
    "Underspin",
    "Big Serve",
    "Volley",
    "Stance",
    "Block",
  ];

  const cards = [
    { title: "Tennis", icon: TennisSport },
    { title: "Soccer", icon: SoccerSport },
    { title: "Baseball", icon: BaseballSport },
    { title: "Skating", icon: SkatingSport },
    { title: "Football", icon: FootballSport },
    { title: "Basketball", icon: BasketballSport },
    { title: "Golf", icon: GolfSport },
  ];

  useEffect(() => {
    isMobileViewHook(setIsMobile, 992);
  }, [window.innerWidth]);

  const addProgressWidth = () => {
    setProgressBar(progressBar + 16.66);
  };

  const subProgressWidth = () => {
    setProgressBar(progressBar - 16.66);
  };

  const titleStyle = isMobile
    ? {
      ...Fonts.h5,
      fontWeight: 400,
      padding: "4px 12px 10px 12px",
      width: "auto",
    }
    : {
      ...Fonts.h7,
      lineHeight: "24px",
      fontFamily: "inter-600",
      width: "100%",
    };

  return (
    <>
      <style jsx>{`
        .${PlayCardClasses.selectImage} {
          top: 60%;
        }
        .${DoubleCalanderCss?.DoubleCalander} {
          // width: 860px;
        }
        .mehru > div {
          justify-content: center;
          display: flex;
        }
        .mehru > div > div {
          display: block;
          width: 50%;
        }
        .mehru > div > div div:nth-child(2) {
          display: flex;
          justify-content: space-evenly;
        }
        .mehru .PrivatePickersSlideTransition-root > div div {
          display: flex;
          justify-content: space-evenly;
        }
      `}</style>
      <div className={`${[classes.coachingStartProfileSetup].join(" ")}`}>
        <BeforeLoginHeader
          icon={logoColor}
          customStyle={{ padding: "24px" }}
          wrapperStyle={{ padding: "0px" }}
        />
        <div
          className={[classes.progressMainDiv]}
          style={{ background: `${Colors.mainShadeOfSolitude}` }}
        >
          <div
            className={[classes.progressInnerDiv]}
            style={{
              background: `${Colors.mainBlue}`,
              width: `${progressBar}%`,
            }}
          />
        </div>
        <Container fluid className={classes.mainContainer}>
          <p
            style={{
              color: Colors.neutralShadesOfDimGray,
              ...Fonts.p1,
            }}
            className={[classes.count]}
          >
            {pageCount} Out of 6
          </p>

          <Row className="g-0">
            {/* <div className={classes.padding}>
              {isMobile ? (
                <MobileHeader
                  isLogo={true}
                  isAvatar={false}
                  customStyle={{ paddingTop: "16px", paddingLeft: "16px" }}
                />
              ) : (
                <BeforeLoginHeader icon={logoColor} />
              )}
            </div> */}

            {pageCount == 1 && (
              <>
                <Col md={12}>
                  <h2
                    style={{
                      color: Colors.neutralShadesOfNero,
                      ...Fonts.h2,
                    }}
                    className={[classes.heading]}
                  >
                    Let’s find the
                    <span className={classes.overlayImg}>
                      right
                      {selectedValue == null && <img src={HeadingBg} />}
                    </span>
                    coach for you
                  </h2>
                  <p
                    style={{
                      color: Colors.neutralShadesOfDimGray,
                      ...Fonts.p1,
                    }}
                    className={[classes.description]}
                  >
                    What kind of sport are you interested in?
                  </p>
                </Col>
                <Col md={12}>
                  <div className={`${[classes.cardsContainer].join(" ")}`}>
                    {cards?.map((item) => {
                      return (
                        <div className={`${[classes.card].join(" ")}`}>
                          <PlayCard
                            title={item.title}
                            icon={item?.icon}
                            iconStyle={{
                              width: isMobile ? "80px" : "96px",
                              height: isMobile ? "80px" : "96px",
                              marginBottom: !isMobile && "16px",
                            }}
                            customStyle={{
                              alignItems: isMobile ? "center" : "center",
                              justifyContent: isMobile && "unset",
                              flexDirection: isMobile && "row",
                            }}
                            titleStyle={{
                              marginLeft: isMobile && "24px",
                              ...titleStyle,
                            }}
                            value={""}
                            selectedData={selectedValue}
                            onClick={() => setSelectedValue(item?.title)}
                            showSelection={true}
                          />
                        </div>
                      );
                    })}
                  </div>
                </Col>
              </>
            )}
            {pageCount == 2 && (
              <>
                <Col md={12}>
                  <h2
                    style={{
                      color: Colors.neutralShadesOfNero,
                      ...Fonts.h2,
                    }}
                    className={[classes.heading]}
                  >
                    What time works best for you?
                  </h2>
                  <p
                    style={{
                      color: Colors.neutralShadesOfDimGray,
                      ...Fonts.p1,
                    }}
                    className={[classes.description]}
                  >
                    Choose the most convenient times for you.
                  </p>
                </Col>
                <Col md={12}>
                  <div className={`${classes.dayRoutine_main_container}`}>
                    {timingCardArray?.map((item) => {
                      return (
                        <>
                          <div
                            className={`${classes.dayRoutine_container}`}
                            onClick={() => setTimingCard(item)}
                          >
                            <div
                              style={{
                                borderBottom: `2px solid ${timingCard?.title === item?.title
                                  ? Colors.mainBlue
                                  : Colors.neutralShadesOfWhisper
                                  }`,
                                paddingBottom: "18px",
                              }}
                            >
                              <div
                                className={`${classes.dayRoutine_inner_container}`}
                              >
                                <div
                                  className={`${classes.dayRoutine_image_container}`}
                                >
                                  <img src={item?.icon} />
                                </div>
                              </div>
                              <h6
                                style={{
                                  color: Colors.neutralShadesOfNero,
                                  ...Fonts.h7,
                                  marginBottom: "4px",
                                }}
                              >
                                {item?.timing}
                              </h6>
                              <p
                                style={{
                                  color: Colors.neutralShadesOfDimGray,
                                  ...Fonts.p1,
                                }}
                              >
                                {item?.title}
                              </p>
                            </div>
                          </div>
                        </>
                      );
                    })}
                  </div>
                </Col>
              </>
            )}
            {pageCount == 3 && (
              <>
                <Col md={12}>
                  <h2
                    style={{
                      color: Colors.neutralShadesOfNero,
                      ...Fonts.h2,
                    }}
                    className={[classes.heading]}
                  >
                    Date availability
                  </h2>
                  <p
                    style={{
                      color: Colors.neutralShadesOfDimGray,
                      ...Fonts.p1,
                    }}
                    className={[classes.description]}
                  >
                    Choose the most convenient times for you.
                  </p>
                </Col>
                <Col md={12}>
                  <div className={`${classes.calandar_inner_container}`}>
                    <DoubleCalander />
                  </div>
                </Col>
              </>
            )}
            {pageCount == 4 && (
              <>
                <Col md={12}>
                  <h2
                    style={{
                      color: Colors.neutralShadesOfNero,
                      ...Fonts.h2,
                    }}
                    className={[classes.heading]}
                  >
                    Location
                  </h2>
                  <p
                    style={{
                      color: Colors.neutralShadesOfDimGray,
                      ...Fonts.p1,
                    }}
                    className={[classes.description]}
                  >
                    Where would you want to take your lessons.
                  </p>
                </Col>
                <Col md={12}>
                  <div className={`${classes.map_main_container}`}>
                    <Row className={[classes.mapPlacesRow]}>
                      <Col md={6}>
                        <Maps
                          type={"places"}
                          label={"Enter your address"}
                          setAddress={setAddress}
                          placeholder={"19, Columbus circle"}
                          setCoordinates={setCoordinate}
                          setPlaceDetail={setLocationDetail}
                        />
                      </Col>
                      <Col md={6}>
                        <DropDown
                          label={"Search within"}
                          placeholder={"10 miles radius"}
                          customStyle={{ height: "82px" }}
                          state={radius}
                          setter={setRadius}
                          options={[
                            {
                              label: "10 miles radius",
                              value: "10 miles radius",
                            },
                            {
                              label: "20 miles radius",
                              value: "20 miles radius",
                            },
                            {
                              label: "30 miles radius",
                              value: "30 miles radius",
                            },
                            {
                              label: "40 miles radius",
                              value: "40 miles radius",
                            },
                            {
                              label: "50+ miles radius",
                              value: "50+ miles radius",
                            },
                          ]}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col md={12}>
                        <div style={{ height: "364px", marginTop: "16px" }}>
                          <Maps
                            type={"map"}
                            location={{ lat: 32.715736, lng: -117.161087 }}
                            mapClass={classes.mapsBorder}
                          />
                        </div>
                      </Col>
                    </Row>

                    {/* <MapView/> */}
                  </div>
                </Col>
              </>
            )}

            {pageCount == 5 && (
              <>
                <Col md={12}>
                  <h2
                    style={{
                      color: Colors.neutralShadesOfNero,
                      ...Fonts.h2,
                    }}
                    className={[classes.heading]}
                  >
                    Coach qualities
                  </h2>
                </Col>
                <Col md={12}>
                  <Row
                    style={{
                      borderBottom: `1px solid ${Colors.neutralShadesOfWhisper}`,
                    }}
                    className={[classes.checkRow]}
                  >
                    {coachQualitiesArray.map((item, i) => {
                      return (
                        <Col md={4} key={i} className={classes.checkboxCol}>
                          <Checkbox
                            label={item}
                            value={coachQualities}
                            setValue={(e) => {
                              setCoachQualities(e);
                              if (e.length > 1) {
                                setUnSelectCoachQualities(["Unselect all"]);
                              }
                            }}
                          />
                        </Col>
                      );
                    })}
                  </Row>
                  <Checkbox
                    label={"Unselect all"}
                    value={unSelectCoachQualities}
                    disabled={coachQualities?.length > 1 ? false : true}
                    setValue={(e) => {
                      setUnSelectCoachQualities(e);
                      setCoachQualities([]);
                    }}
                    type={"unselect"}
                  />
                </Col>
              </>
            )}

            {pageCount == 6 && (
              <>
                <Col md={12}>
                  <h2
                    style={{
                      color: Colors.neutralShadesOfNero,
                      ...Fonts.h2,
                    }}
                    className={[classes.heading]}
                  >
                    Skills taught
                  </h2>
                </Col>
                <Col md={12}>
                  <Row
                    style={{
                      borderBottom: `1px solid ${Colors.neutralShadesOfWhisper}`,
                    }}
                    className={[classes.checkRow]}
                  >
                    {skillsTaughtArray.map((item, i) => {
                      return (
                        <Col md={4} key={i} className={classes.checkboxCol}>
                          <Checkbox
                            label={item}
                            value={skillsTaught}
                            setValue={(e) => {
                              setSkillsTaught(e);
                              if (e.length > 1) {
                                setUnSelectSkillsTaught(["Unselect all"]);
                              }
                            }}
                          />
                        </Col>
                      );
                    })}
                  </Row>
                  <Checkbox
                    label={"Unselect all"}
                    value={unSelectSkillsTaught}
                    setValue={(e) => {
                      setUnSelectSkillsTaught(e);
                      setSkillsTaught([]);
                    }}
                    type={"unselect"}
                  />
                </Col>
              </>
            )}

            <Col
              md={12}
              className={`${[
                classes.innerContainer,
                classes.startProfileBtnBox,
              ].join(" ")}`}
            >
              {pageCount > 1 && (
                <Button
                  label={"Go Back"}
                  disabled={pageCount > 1 ? false : true}
                  light={true}
                  size={"Large"}
                  customStyle={{
                    width: isMobile ? "100%" : "200px",
                    height: "56px",
                    marginRight: "10px",
                  }}
                  onClick={() => {
                    setPageCount((p) => p - 1);
                    subProgressWidth();
                  }}
                />
              )}
              <Button
                label={pageCount === 6 ? "Finish" : "Next"}
                disabled={selectedValue === null ? true : false}
                // disabled={pageCount > 0 ? false : true}
                primary={true}
                size={"Large"}
                customStyle={{
                  width: isMobile ? "100%" : "200px",
                  height: "56px",
                }}
                onClick={() => {
                  setPageCount((p) => {
                    if (p < 6) return p + 1
                    else return p
                  });
                  addProgressWidth();
                }}
              />
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default function GetAMatch() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    isMobileViewHook(setIsMobile, 992);
  }, []);
  return isMobile ? <GetAMatchMobile /> : <GetAMatchDesktop />;
}
